import React, { memo } from "react";

import styles from "./styles.module.scss";
import TrackingProgress from "./TrackingProgress";
// import dayjs from "dayjs";
import { useTrackingData } from "../../shared/hooks/useTrackingData";

const TrackingSection = ({ responseData, trackingNumber }) => {
  const trackingData = useTrackingData(responseData, trackingNumber);
  // const timeOfArrival =
  //   dayjs(responseData.estimatedArrivalDate).format("DD.MM.YYYY") || "-";
  // const showWidthDelay = trackingData.isDelay ? "Задержка" : timeOfArrival;
  return (
    <section className={styles.trackingSection}>
      <div className={styles.trackingSectionTop}>
        <h2>Номер посылки</h2>
        {/* <div className={styles.headingFlex}>
          {(trackingData?.isDelivered || !trackingData?.isDelay) && (
            <p>
              Ожидается:{" "}
              <span>{trackingData?.deliveredStr || timeOfArrival}</span>
            </p>
          )}
          <p>
            Дней в пути: <span>{trackingData?.daysInTransit}</span>{" "}
          </p>
        </div> */}
      </div>
      <TrackingProgress
        data={trackingData}
        progress={trackingData.progress}
        isDelivered={trackingData.isDelivered}
      />
    </section>
  );
};

export default memo(TrackingSection);
